export default __webpack_public_path__ + "static/media/bg_main1.e4ce66ba.png";